export const faqs = [
  {
    q: 'How will I receive Obesity Clinical Blueprint™?',
    a: 'After your payment is confirmed, you will receive instructions for accessing and downloading the included digital materials.',
  },
  {
    q: 'Is the material suitable for healthcare professionals in different countries?',
    a: 'The collection is designed as an educational and organizational reference. Clinical guidelines, prescribing requirements, professional scopes of practice, and treatment recommendations vary by jurisdiction. You should verify clinical information against current local guidance before applying it in practice.',
  },
  {
    q: 'Do I need to be an obesity specialist?',
    a: 'The collection is intended for qualified healthcare professionals who participate in adult obesity care, within their professional scope of practice. It may be useful to professionals in primary care, internal medicine, endocrinology, and other relevant specialties.',
  },
  {
    q: 'Does the product provide individualized treatment recommendations?',
    a: 'No. The materials are designed to help organize clinical information and treatment reviews. They do not independently diagnose patients, prescribe treatments, determine treatment eligibility, or replace individualized professional judgment.',
  },
  {
    q: 'Are the files downloadable?',
    a: 'Yes. The product is delivered digitally, and the included materials can be downloaded for personal professional reference.',
  },
  {
    q: 'Can I print the worksheets?',
    a: 'Yes. The worksheets and checklists are designed to be printable for use within your existing professional workflow.',
  },
  {
    q: 'Is this a recurring subscription?',
    a: 'No. The offer is a one-time payment of $27 USD for access to the edition you purchase.',
  },
  {
    q: 'Does Obesity Clinical Blueprint™ replace official clinical guidelines?',
    a: 'No. It is a practical educational reference and organizational resource. You must consult current evidence, official guidance, prescribing information, and applicable local protocols when making clinical decisions.',
  },
  {
    q: "What if the product isn't right for me?",
    a: 'Your purchase is covered by the stated seven-day money-back guarantee. Contact us within the guarantee period to request a refund under the applicable terms.',
  },
];
